export class InsolesCamProfileModel {
    versionNumber: string;
    code: string;
    label: string;
}
